import { render, staticRenderFns } from "./ErpDlsKucun.vue?vue&type=template&id=0fdf50c3&scoped=true&"
import script from "./ErpDlsKucun.vue?vue&type=script&lang=js&"
export * from "./ErpDlsKucun.vue?vue&type=script&lang=js&"
import style0 from "./ErpDlsKucun.vue?vue&type=style&index=0&id=0fdf50c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf50c3",
  null
  
)

export default component.exports